import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';
import { LottieAnimationViewModule } from 'ng-lottie';

import { RmtAppBarComponent } from './rmt-app-bar/rmt-app-bar';
import { RmtHeaderComponent } from './rmt-header/rmt-header';
import { RmtFooterComponent } from './rmt-footer/rmt-footer';
import { RmtTitleComponent } from './rmt-title/rmt-title';
import { RmtPickerComponent } from './rmt-picker/rmt-picker';
import { RmtCardComponent } from './rmt-card/rmt-card';
import { RmtCountryComponent } from './rmt-country/rmt-country';
import { RmtCountrySendComponent } from './rmt-country-send/rmt-country-send';
import { RmtCurrencyComponent } from './rmt-currency/rmt-currency';
import { RmtCurrencyNewComponent } from './rmt-currency-new/rmt-currency-new';
import { RmtContentLoaderComponent } from './rmt-content-loader/rmt-content-loader';
import { RmtInputLoaderComponent } from './rmt-input-loader/rmt-input-loader';
import { RmtLanguageComponent } from './rmt-language/rmt-language';
import { RmtPhoneComponent } from './rmt-phone/rmt-phone';
import { RmtStepsComponent } from './rmt-steps/rmt-steps';
import { RmtDateComponent } from './rmt-date/rmt-date';
import { RmtPasswordComponent } from './rmt-password/rmt-password';
import { RmtInitialsComponent } from './rmt-initials/rmt-initials';
import { RmtSeparatorComponent } from './rmt-separator/rmt-separator';
import { RmtInputIconComponent } from './rmt-input-icon/rmt-input-icon';
import { RmtHintComponent } from './rmt-hint/rmt-hint';
import { RmtListCardComponent } from './rmt-list-card/rmt-list-card';
import { RmtListItemComponent } from './rmt-list-item/rmt-list-item';
import { RmtListItemNewComponent } from './rmt-list-item-new/rmt-list-item-new';
import { RmtSearchCityComponent } from './rmt-search-city/rmt-search-city';
import { RmtBankDepositComponent } from './rmt-bank-deposit/rmt-bank-deposit';
import { RmtDynamicFormComponent } from './rmt-dynamic-form/rmt-dynamic-form';
import { RmtDynamicFormFieldComponent } from './rmt-dynamic-form-field/rmt-dynamic-form-field';
import { RmtErrorComponent } from './rmt-error/rmt-error';
import { RmtTooltipComponent } from './rmt-tooltip/rmt-tooltip';
import { RmtLocationListItem } from './rmt-location-list-item/rmt-location-list-item';
import { RmtLocationDetailsComponent } from './rmt-location-details/rmt-location-details';
import { RmtNewEntryComponent } from './rmt-new-entry/rmt-new-entry';
import { RmtPopupComponent } from './rmt-popup/rmt-popup';
import { RmtSnackbarComponent } from './rmt-snackbar/rmt-snackbar';
import { RmtInternalIssueReporterComponent } from './rmt-internal-issue-reporter/rmt-internal-issue-reporter';
import { RmtRemoveEntryComponent } from './rmt-remove-entry/rmt-remove-entry';
import { RmtCircleComponent } from './rmt-circle/rmt-circle';
import { RmtCenterComponent } from './rmt-center/rmt-center';
import { RmtErrorMessageComponent } from './rmt-error-message/rmt-error-message';
import { RmtCheckboxComponent } from './rmt-checkbox/rmt-checkbox';
import { RmtWorldpayCardFieldsComponent } from './rmt-worldpay-card-fields/rmt-worldpay-card-fields';
import { RmtSubmitButtonComponent } from './rmt-submit-button/rmt-submit-button';
import { RmtTransferDetailsComponent } from './rmt-transfer-details/rmt-transfer-details';
import { RmtTrackTimelineComponent } from './rmt-track-timeline/rmt-track-timeline';
import { RmtTransferStatusWidgetComponent } from './rmt-transfer-status-widget/rmt-transfer-status-widget';
import { RmtMapComponent } from './rmt-map/rmt-map';
import { RmtContentComponent } from './rmt-content/rmt-content';
import { RmtCardItemComponent } from './rmt-card-item/rmt-card-item';
import { RmtShareOrderComponent } from './rmt-share-order/rmt-share-order';
import { RmtVirtualScrollComponent } from './rmt-virtual-scroll/rmt-virtual-scroll';
import { RmtVirtualScrollItemComponent } from './rmt-virtual-scroll-item/rmt-virtual-scroll-item';
import { RmtTranslateComponent } from './rmt-translate/rmt-translate';
import { RmtClipboardComponent } from './rmt-clipboard/rmt-clipboard';
import { RmtSelectPickerComponent } from './rmt-select-picker/rmt-select-picker';
import { RmtPromoCodeComponent } from './rmt-promo-code/rmt-promo-code';
import { RmtAccordionComponent } from './rmt-accordion/rmt-accordion';
import { RmtDropdownItemComponent } from './rmt-dropdown-content/rmt-dropdown-content';
import { RmtRateSelectorComponent } from './rmt-rate-selector/rmt-rate-selector';
import { RmtLoginComponent } from './rmt-login/rmt-login';
import { RmtSelectActionSheetComponent } from './rmt-select-actionsheet/rmt-select-actionsheet';
import { RmtClipboardContainerComponent } from './rmt-clipboard-container/rmt-clipboard-container';
import { RmtInfoComponent } from './rmt-info/rmt-info';
import { RmtPromoRowComponent } from './rmt-promo-row/rmt-promo-row';
import { RmtPromoRowNewComponent } from './rmt-promo-row-new/rmt-promo-row-new';

// MyRIA
import { InfoContent } from '../components/myria/info-content/info-content';
import { RiaKeyboardComponent } from '../components/myria/ria-keyboard/ria-keyboard';
import { SharedPipesModule } from '../shared/shared-pipes.module';
import { TimerComponentModule } from '../components/myria/timer-component/timer-component.module';
import { FooterButtonComponentModule } from '../components/myria/footer-button/footer-button.module';
import { CheckboxTextModule } from '../components/myria/checkbox-text/checkbox-text.module';
import { ImageAndTextComponent } from '../components/myria/layouts/two-columns/image-and-text/image-and-text';
import { SearchSelectInputComponent } from '../components/myria/search-select-input/search-select-input';

import { ActivityItemComponent } from './activity-item/activity-item';
import { ActivityItemNewComponent } from './activity-item-new/activity-item-new';
import { RmtWalletListItem } from './rmt-wallet-list-item/rmt-wallet-list-item';
import { RmtNotifyBarComponent } from './rmt-notify-bar/rmt-notify-bar';
import { RmtNotifyCardComponent } from './rmt-notify-card/rmt-notify-card';
import { RmtDashboardCardComponent } from './rmt-dashboard-card/rmt-dashboard-card';

import { XeVisibilityComponent } from './xe-visibility/xe-visibility';
import { XeLottieComponent } from './xe-lottie/xe-lottie';
import { XeDotComponent } from './xe-dot/xe-dot';
import { XeCaptchaComponent } from './xe-captcha/xe-captcha';
import { RmtContactListItem } from './rmt-contact-list-item/rmt-contact-list-item';
import { RmtWarningCardComponent } from './rmt-warning-card/rmt-warning-card';
import { RmtSkeletonTransactionComponent } from './rmt-skeleton-transaction/rmt-skeleton-transaction';
import { RmtSkeletonSlidesComponent } from './rmt-skeleton-slides/rmt-skeleton-slides';

import { MissingTranslationHandler, TranslateParser } from '@ngx-translate/core';
import { TranslationFallbackHandler } from '../translations';
import { TranslationParserHandler } from '../translations';
import { RmtLoqateComponent } from './rmt-loqate/rmt-loqate';
import { RmtEmptyPickerComponent } from './rmt-empty-picker/rmt-empty-picker';
import { RmtSkeletonLoaderComponent } from './rmt-skeleton-loader/rmt-skeleton-loader';
import { DirectivesModule } from '../directives/directives.module';
import { RmtAlertsComponent } from './rmt-alerts/rmt-alerts';
import { RmtInputComponent } from './rmt-input/rmt-input';
import { RmtInputSearchComponent } from './rmt-input-search/rmt-input-search';

import { RmtTextAreaComponent } from './rmt-text-area/rmt-text-area';
import { RmtModalComponent } from './rmt-modal/rmt-modal';
import { RmtWalletCardsComponent } from './rmt-wallet-cards/rmt-wallet-cards';
import { RmtWaitingComponent } from './rmt-waiting/rmt-waiting';
import { RmtWalletCardSelectionComponent } from './rmt-wallet-card-selection/rmt-wallet-card-selection';
import { RmtCardNewComponent } from './rmt-card-new/rmt-card-new';
import { RmtMenuButtonComponent } from './rmt-menu-button/rmt-menu-button';
import { ActivityMenuFilterComponent } from './activity-menu-filter/activity-menu-filter';
import { RmtWalletProfileSkeletonComponent } from './rmt-wallet-profile-skeleton/rmt-wallet-profile-skeleton';
import { RmtSearchBarInputComponent } from './rmt-searchbar-input/rmt-searchbar-input';
import { RmtGroupItemComponent } from './rmt-group-item/rmt-group-item';
import { RmtSegmentButtonComponent } from './rmt-segment-button/rmt-segment-button';
import { RmtContactsComponent } from './rmt-contacts/rmt-contacts';
import { RmtTileNewComponent } from './rmt-tile-new/rmt-tile-new';
import { RmtCardTransactionComponent } from './rmt-card-transaction/rmt-card-transaction';
import { RmtChipsComponent } from './rmt-chips/rmt-chips';
import { RmtSendSummarySmallComponent } from './rmt-send-summary-small/rmt-send-summary-small';
import { RmtPaymentAccountComponent } from './rmt-payment-account/rmt-payment-account';
import { RmtWalletBalanceAndQrComponent } from './rmt-wallet-balance-and-qr/rmt-wallet-balance-and-qr';
import { RmtWalletServicesComponent } from './rmt-wallet-services/rmt-wallet-services';
import { RmtReferralcodeLabelComponent } from './rmt-referralcode-label/rmt-referralcode-label';
import { RmtBillerHeaderComponent } from './rmt-biller-header/rmt-biller-header';
import { RmtSlides } from './rmt-slides/rmt-slides';
import { RmtLabelsComponent } from './rmt-labels/rmt-labels';
import { RmtRibbonsComponent } from './rmt-ribbons/rmt-ribbons';
import { RmtGoogleButtonComponent } from './rmt-google-button/rmt-google-button';
import { RmtDebitCardComponent } from './rmt-debit-card/rmt-debit-card';
import { NgxMaskModule } from 'ngx-mask'
import { RmtSelectListComponent } from './rmt-select-list/rmt-select-list';
import { RmtRateWidgetComponent } from './rmt-rate-widget/rmt-rate-widget';
import { RmtHomeRateWidgetComponent } from './rmt-home-rate-widget/rmt-home-rate-widget';
import { RmtHomeHeroComponent } from './rmt-home-hero/rmt-home-hero';
import { RmtHomePartnersComponent } from './rmt-home-partners/rmt-home-partners';
import { RmtHomeContinueTransferComponent } from './rmt-home-continue-transfer/rmt-home-continue-transfer';
import { RmtRotatingRateComponent } from './rmt-rotating-rate/rmt-rotating-rate';
import { RmtShimmerTextComponent } from './rmt-shimmer-text/rmt-shimmer-text';
import { RmtTimerComponent } from './rmt-timer/rmt-timer';
import { RmtAddressUpdateComponent } from './rmt-address-update/rmt-address-update';
import { RmtDebugMenuComponentModule } from './rmt-debug-menu/rmt-debug-menu.module';
import { RmtDebugConsoleComponent } from './rmt-debug-console/rmt-debug-console';

@NgModule({
  declarations: [
    RmtWorldpayCardFieldsComponent,
    RmtAppBarComponent,
    RmtHeaderComponent,
    RmtDebugConsoleComponent,
    RmtFooterComponent,
    RmtTitleComponent,
    RmtPickerComponent,
    RmtCardComponent,
    RmtCountryComponent,
    RmtCountrySendComponent,
    RmtCurrencyComponent,
    RmtCurrencyNewComponent,
    RmtContentLoaderComponent,
    RmtInputLoaderComponent,
    RmtLanguageComponent,
    RmtPhoneComponent,
    RmtStepsComponent,
    RmtDateComponent,
    RmtPasswordComponent,
    RmtInitialsComponent,
    RmtSeparatorComponent,
    RmtInputIconComponent,
    RmtHintComponent,
    RmtListCardComponent,
    RmtListItemComponent,
    RmtGroupItemComponent,
    RmtListItemNewComponent,
    RmtSearchCityComponent,
    RmtBankDepositComponent,
    RmtDynamicFormComponent,
    RmtDynamicFormFieldComponent,
    RmtErrorComponent,
    RmtTooltipComponent,
    RmtLocationListItem,
    RmtLocationDetailsComponent,
    RmtNewEntryComponent,
    RmtPopupComponent,
    RmtSnackbarComponent,
    RmtInternalIssueReporterComponent,
    RmtRemoveEntryComponent,
    RmtCircleComponent,
    RmtCenterComponent,
    RmtErrorMessageComponent,
    RmtCheckboxComponent,
    RmtSubmitButtonComponent,
    RmtTransferDetailsComponent,
    RmtTrackTimelineComponent,
    RmtTransferStatusWidgetComponent,
    RmtMapComponent,
    RmtContentComponent,
    RmtCardItemComponent,
    RmtShareOrderComponent,
    RmtVirtualScrollComponent,
    RmtVirtualScrollItemComponent,
    RmtTranslateComponent,
    RmtClipboardComponent,
    RmtSelectPickerComponent,
    RmtPromoCodeComponent,
    RmtAccordionComponent,
    RmtDropdownItemComponent,
    RmtRateSelectorComponent,
    RmtLoginComponent,
    RmtSelectActionSheetComponent,
    RmtInfoComponent,
    RmtPromoRowComponent,
    RmtSearchBarInputComponent,
    RmtSegmentButtonComponent,
    RmtSelectListComponent,

    // MyRIA
    InfoContent,
    RiaKeyboardComponent,
    ImageAndTextComponent,
    SearchSelectInputComponent,

    ActivityItemComponent,
    ActivityItemNewComponent,
    XeVisibilityComponent,
    XeLottieComponent,
    XeDotComponent,
    XeCaptchaComponent,
    RmtWalletListItem,
    RmtNotifyBarComponent,
    RmtNotifyCardComponent,
    RmtDashboardCardComponent,
    RmtContactListItem,
    RmtWarningCardComponent,
    RmtSkeletonTransactionComponent,
    RmtSkeletonSlidesComponent,
    RmtClipboardContainerComponent,
    RmtLoqateComponent,
    RmtEmptyPickerComponent,
    RmtSkeletonLoaderComponent,
    RmtAlertsComponent,
    RmtInputComponent,
    RmtInputSearchComponent,
    RmtTextAreaComponent,
    RmtModalComponent,
    RmtWalletCardsComponent,
    RmtWaitingComponent,
    RmtWalletCardSelectionComponent,
    RmtCardNewComponent,
    RmtMenuButtonComponent,
    ActivityMenuFilterComponent,
    RmtWalletProfileSkeletonComponent,
    RmtContactsComponent,
    RmtPromoRowNewComponent,
    RmtTileNewComponent,
    RmtCardTransactionComponent,
    RmtChipsComponent,
    RmtSendSummarySmallComponent,
    RmtPaymentAccountComponent,
    RmtWalletBalanceAndQrComponent,
    RmtWalletServicesComponent,
    RmtReferralcodeLabelComponent,
    RmtBillerHeaderComponent,
    RmtSlides,
    RmtLabelsComponent,
    RmtRibbonsComponent,
    RmtDebitCardComponent,
    RmtRateWidgetComponent,
    RmtHomeRateWidgetComponent,
    RmtHomeHeroComponent,
    RmtHomePartnersComponent,
    RmtHomeContinueTransferComponent,
    RmtRotatingRateComponent,
    RmtShimmerTextComponent,
    RmtDebitCardComponent,
    RmtTimerComponent,
    RmtAddressUpdateComponent,
    RmtRibbonsComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: TranslationFallbackHandler },
      parser: {provide: TranslateParser, useClass: TranslationParserHandler}
    }),

    SharedPipesModule,
    LottieAnimationViewModule.forRoot(),
    DirectivesModule,
    NgxMaskModule.forRoot(),
    RmtDebugMenuComponentModule

  ],
  exports: [
    TranslateModule,
    RmtWorldpayCardFieldsComponent,
    RmtAppBarComponent,
    RmtHeaderComponent,
    RmtDebugConsoleComponent,
    RmtFooterComponent,
    RmtTitleComponent,
    RmtPickerComponent,
    RmtCardComponent,
    RmtCountryComponent,
    RmtCountrySendComponent,
    RmtCurrencyComponent,
    RmtCurrencyNewComponent,
    RmtContentLoaderComponent,
    RmtInputLoaderComponent,
    RmtLanguageComponent,
    RmtPhoneComponent,
    RmtStepsComponent,
    RmtDateComponent,
    RmtPasswordComponent,
    RmtInitialsComponent,
    RmtSeparatorComponent,
    RmtInputIconComponent,
    RmtHintComponent,
    RmtListCardComponent,
    RmtListItemComponent,
    RmtGroupItemComponent,
    RmtListItemNewComponent,
    RmtSearchCityComponent,
    RmtBankDepositComponent,
    RmtDynamicFormComponent,
    RmtDynamicFormFieldComponent,
    RmtErrorComponent,
    RmtTooltipComponent,
    RmtLocationListItem,
    RmtLocationDetailsComponent,
    RmtNewEntryComponent,
    RmtPopupComponent,
    RmtSnackbarComponent,
    RmtInternalIssueReporterComponent,
    RmtRemoveEntryComponent,
    RmtCircleComponent,
    RmtCenterComponent,
    RmtErrorMessageComponent,
    RmtCheckboxComponent,
    RmtSubmitButtonComponent,
    RmtTransferDetailsComponent,
    RmtTrackTimelineComponent,
    RmtTransferStatusWidgetComponent,
    RmtMapComponent,
    RmtContentComponent,
    RmtCardItemComponent,
    RmtShareOrderComponent,
    RmtVirtualScrollComponent,
    RmtVirtualScrollItemComponent,
    RmtTranslateComponent,
    RmtClipboardComponent,
    RmtSelectPickerComponent,
    RmtPromoCodeComponent,
    RmtAccordionComponent,
    RmtDropdownItemComponent,
    RmtRateSelectorComponent,
    RmtLoginComponent,
    RmtSelectActionSheetComponent,
    RmtInfoComponent,
    RmtPromoRowComponent,
    RmtSearchBarInputComponent,
    RmtSegmentButtonComponent,
    RmtSelectListComponent,

    // MyRIA
    CheckboxTextModule,
    InfoContent,
    RiaKeyboardComponent,
    SharedPipesModule,
    TimerComponentModule,
    FooterButtonComponentModule,
    ImageAndTextComponent,
    SearchSelectInputComponent,

    ActivityItemComponent,
    ActivityItemNewComponent,
    XeVisibilityComponent,
    XeLottieComponent,
    XeDotComponent,
    XeCaptchaComponent,
    RmtWalletListItem,
    RmtNotifyBarComponent,
    RmtNotifyCardComponent,
    RmtDashboardCardComponent,
    RmtContactListItem,
    RmtWarningCardComponent,
    RmtSkeletonTransactionComponent,
    RmtSkeletonSlidesComponent,
    RmtClipboardContainerComponent,
    RmtLoqateComponent,
    RmtEmptyPickerComponent,
    RmtSkeletonLoaderComponent,
    RmtAlertsComponent,
    RmtInputComponent,
    RmtInputSearchComponent,
    RmtTextAreaComponent,
    RmtModalComponent,
    RmtWalletCardsComponent,
    RmtWaitingComponent,
    RmtWalletCardSelectionComponent,
    RmtCardNewComponent,
    RmtMenuButtonComponent,
    ActivityMenuFilterComponent,
    RmtWalletProfileSkeletonComponent,
    RmtContactsComponent,
    RmtPromoRowNewComponent,
    RmtTileNewComponent,
    RmtCardTransactionComponent,
    RmtChipsComponent,
    RmtSendSummarySmallComponent,
    RmtPaymentAccountComponent,
    RmtWalletBalanceAndQrComponent,
    RmtWalletServicesComponent,
    RmtReferralcodeLabelComponent,
    RmtBillerHeaderComponent,
    RmtSlides,
    RmtLabelsComponent,
    RmtRibbonsComponent,
    RmtDebitCardComponent,
    RmtRateWidgetComponent,
    RmtHomeRateWidgetComponent,
    RmtHomeHeroComponent,
    RmtHomePartnersComponent,
    RmtHomeContinueTransferComponent,
    RmtRotatingRateComponent,
    RmtShimmerTextComponent,
    RmtDebitCardComponent,
    RmtTimerComponent,
    RmtAddressUpdateComponent,
    RmtRibbonsComponent,
    RmtDebugMenuComponentModule,
  ],
  entryComponents: [
    RmtSnackbarComponent,
    RmtSkeletonLoaderComponent,
    RmtAlertsComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts